import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, FormGroupDirective } from '@angular/forms';

import { FormConfigService } from 'src/app/form-config/form-config.service';
import { Records } from 'src/app/form-config/model/records.type';
import { AGENT_TYPE } from '../../model/consts/agent-type.const';

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss'],
})
export class AgentsComponent implements OnInit {
  @Input() formGroupName: string;
  @Input() formName: string;
  @Output() emitAdd: EventEmitter<any> = new EventEmitter();
  @Output() emitDelete: EventEmitter<any> = new EventEmitter();

  form: UntypedFormGroup;
  agentTypeItems: Records;
  labels: Record<string, any>;

  constructor(
    private formConfigService: FormConfigService,
    private rootFormGroup: FormGroupDirective
  ) { }

  ngOnInit(): void {
    this.labels = this.formConfigService.getLabels();
    this.form = this.rootFormGroup.control.get(this.formGroupName) as UntypedFormGroup;
    this.agentTypeItems = AGENT_TYPE;
  }

  addRow(): void {
    this.emitAdd.emit();
  }

  deleteRow(index: number): void {
    this.emitDelete.emit(index);
  }

  get getRow(): UntypedFormArray {
    return this.form.get('agentsArr') as UntypedFormArray;
  }
}
